import { HashRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import OverView from '../pages/OverView';
import {
  ClientAccessControl,
  PermissionRequired,
} from '@careinfo/permission-required';

export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route
            path='/'
            element={
              <ClientAccessControl
                allowedPermissions={['can_view_overview']}
                renderNoAccess={<PermissionRequired />}
              >
                <OverView />
              </ClientAccessControl>
            }
          />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
